// extracted by mini-css-extract-plugin
export default {"emptyItem":"_2OL0T"};